import { get, keys, map, divide } from 'lodash';

import CartLineItem from 'models/CartLineItem';
import { ADD_TO_CART_ORIGINS } from 'state/constants';
import Gender from 'utils/Gender';

const getItem = (state, id) => get(state, ['ajaxCart', 'data', 'entities', 'item', id]);

const diffItems = (prevItem, nextItem) => ({
  quantity: nextItem.quantity - prevItem.quantity,
});

const upsellAddToCart = (action, prevState, nextState) => {
  const origination = get(action, ['meta', 'origination']);

  // If the source of add to cart was not the upsell component, bail
  if (origination !== ADD_TO_CART_ORIGINS.UPSELL) {
    return null;
  }

  const itemIds = keys(get(action, ['payload', 'addedItems']));

  return map(itemIds, itemId => {
    const prevItem = new CartLineItem(getItem(prevState, itemId));
    const nextItem = new CartLineItem(getItem(nextState, itemId));

    const { quantity } = diffItems(prevItem, nextItem);

    if (quantity < 1) {
      return null;
    }

    const { gender, genericProductTitle, size, color } = nextItem;
    const formattedGender = Gender.getPluralGender(gender);

    return {
      hitType: 'event',
      eventCategory: 'Cart',
      eventLabel: 'Upsell',
      eventAction: 'addToCart',
      eventValue: quantity,
      dimension3: color,
      dimension4: size,
      dimension5: formattedGender,
      dimension7: genericProductTitle,
    };
  });
};

const addProduct = (id, action, prevState, nextState) => {
  const origination = get(action, ['meta', 'origination']);

  // If the source of add to cart was not the pdp upsell modal component, bail
  if (origination !== ADD_TO_CART_ORIGINS.PDP_UPSELL_MODAL) {
    return null;
  }

  const prevItem = new CartLineItem(getItem(prevState, id));
  const nextItem = new CartLineItem(getItem(nextState, id));

  const { quantity } = diffItems(prevItem, nextItem);

  if (quantity < 1) {
    return null;
  }

  const { gender, genericProductTitle, size, color, price, sku } = nextItem;
  const formattedGender = Gender.getPluralGender(gender);

  return {
    hitType: 'event',
    eventAction: 'Add Product',
    eventCategory: 'PDP',
    eventLabel: 'Upsell Modal',
    eventValue: quantity,
    dimension3: color,
    dimension4: size,
    dimension5: formattedGender,
    dimension6: divide(price, 100),
    dimension7: genericProductTitle,
    dimension8: sku,
  };
};

const addMultipleLineItemEvent = (action, prevState, nextState) => {
  const items = get(action, ['payload', 'addedItems']);

  return map(items, (quantity, id) => addProduct(id, action, prevState, nextState));
};

export { upsellAddToCart, addMultipleLineItemEvent };

export default upsellAddToCart;
